import formatMessage from './../i18n/formatMessage';

export default [
  { id: 1, name: formatMessage('acompanhamentoProdutor.toneladas') },
  { id: 2, name: formatMessage('acompanhamentoProdutor.sacas') },
  { id: 3, name: formatMessage('acompanhamentoProdutor.kg') }
];
